import { create } from 'zustand'
import { produce } from 'immer'

export default create((set, get) => ({
  collection: [],
  fetching: false,
  loaded: false,
  async fetch() {
    if (get().loaded || get().fetching) return
    set({ fetching: true })
    const response = await fetch('/api/locations')
    const data = await response.json()
    set({ collection: data, fetching: false, loaded: true })
  },
  setCollection(collection) {
    set({ collection })
  },
}))
